import getColor from "@insite/mobius/utilities/getColor";
import React from "react";

const ManufacturerBrochure = () => {
    return (
        <svg width="47" height="48" viewBox="0 0 47 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#5305y2kt0a)" stroke="#002856" strokeWidth="1.5" strokeLinejoin="round">
                <path d="M2.792 1.853a.895.895 0 0 0-.447-.135 1.005 1.005 0 0 0-.414.11.845.845 0 0 0-.431.743V37.43a.845.845 0 0 0 .397.71l13.962 8.826V10.021a3.623 3.623 0 0 1-.49-.22L2.792 1.853z" />
                <path d="m3.611 21.694 10.136 6.335M3.611 26.762l10.136 6.335" strokeLinecap="round" />
                <path d="M13.07 21.19c0 1.103-.165 1.654-.497 1.654-.497 0-1.151-.39-1.364-.549l-6.82-4.092a.85.85 0 0 1-.319-.68V7.807c0-.296.14-.568.361-.71a.608.608 0 0 1 .705.03l7.616 4.667a.85.85 0 0 1 .318.68v8.716zM16.049 10.038V47l14.722-8.827c.153-.087.314-.158.482-.21V1L16.53 9.827a2.45 2.45 0 0 1-.481.21z" />
                <path
                    d="m29.14 11.558-10.98 6.758M29.14 16.626l-10.98 6.757M29.14 24.228l-10.98 6.757M29.14 29.296l-10.98 6.757"
                    strokeLinecap="round"
                />
                <path d="M45.363 9.86 31.4 1.034v36.945c.169.061.333.135.49.22l12.577 7.948a.845.845 0 0 0 1.293-.718V10.57a.845.845 0 0 0-.397-.71zM43.07 21.19c0 1.103-.166 1.654-.497 1.654-.497 0-1.151-.39-1.364-.549l-6.82-4.092a.85.85 0 0 1-.319-.68V7.807c0-.296.139-.568.361-.71a.608.608 0 0 1 .705.03l7.616 4.667a.85.85 0 0 1 .318.68v8.716z" />
                <path d="m33.512 22.539 10.136 6.335M33.512 27.607l10.136 6.335" strokeLinecap="round" />
            </g>
            <defs>
                <clipPath id="5305y2kt0a">
                    <path fill="#fff" d="M0 0h47v48H0z" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ManufacturerBrochure;
